<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hXHega/tc-custom/9781497698826.jpg?1705807610579" alt="This image is the cover for the book Israel Journal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Israel Journal
      </h1>
      <p class="bookDescription body article font2">
        <b>An honest and stark account of life on the battlefield during the Six-Day War </b><br/><br/> When the historic Six-Day War breaks out in June 1967, Yaël Dayan finds herself on the front lines in the Sinai desert, fighting for her country. Dayan, a journalist, an author, and the daughter of the renowned Israeli general Moshe Dayan, a key military leader in Israel’s War of Independence two decades earlier, offers a female soldier’s unique perspective and observations on life during active combat.<br/>  <br/> Dayan’s wartime journal entries chronicle her time spent in the desert campaign under the command of the legendary Arik Sharon, the battle against Egyptian forces, and the indelible effect these experiences had on her as both a soldier and a woman. As the author so aptly remarks in her diary, “Nothing will be the same now. I have looked at cessation of life, destruction of matter, sorrow of destroyers, agony of the victorious, and it had to leave a mark.”<br/>  <br/> With raw truth and intensity, these snapshots capture the hardships of battle, the mournfulness of loss, and the harshness of war.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Yaël Dayan
      </h2>
      
      <p class="authorDescription body article">Ya&euml;l Dayan is an Israeli author and political figure. Her father, Moshe Dayan, was the military leader who oversaw the stunning capture of Jerusalem during the Six-Day War. Like her father, Dayan served in the Israeli parliament, the Knesset, of which she was a member for ten years with the Labor Party. An outspoken activist, Dayan has been involved with Peace Now and other organizations fostering the peaceful coexistence of Israelis and Palestinians. She has written five novels, including&#160;<I>Three Weeks in October</I>, about the Yom Kippur War. Among Dayan&rsquo;s nonfiction works are&#160;<I>Israel Journal</I>, a memoir about the Six-Day War, and&#160;<I>My Father, His Daughter</I>, a biography of Moshe Dayan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c71b916